<template>
  <div class="main">
    <Modal width="550" v-model="update_idcard_show" title="更新身份证v2" :footer-hide="true">
      <div @click="click_swiper_replace" v-if="swiper_replace_data_list.length > 0" class="nfc_tishi">
        检测到NFC读取过该人员身份证，支持快捷更新，点击查看
        <Icon type="md-arrow-forward" />
        <Icon type="md-arrow-forward" />
      </div>

      <div class="upload_span_txt">
        <div class="upload_icon"></div>
        身份证照片
        <span class="upload_span_txt2">(点图片进行上传,上传会自动识别，并填充到输入框)</span>
      </div>
      <div class="upload_img_div">
        <div>
          <div class="upload_img_title">身份证人像面</div>
          <Upload :on-success="img_a_success" :action="img_a_url + '&resume_id=' + resume_id" :show-upload-list="false"
            :on-progress="img_progress">
            <img v-if="idcard_img_a_url == ''" class="idcard_img" src="@/assets/image/idcard/idcard_a.png" alt="" />
            <img v-else class="idcard_img" :src="idcard_img_a_url" alt="" />
          </Upload>
          <div class="view_idcard_big_img_main">
            <span class="view_idcard_big_img" @click="click_view_img(idcard_img_a_url)">
              <Icon type="ios-eye-outline" />查看大图
            </span>
            <span class="view_idcard_big_img" @click="download_img(idcard_img_a_url, '身份证人像面.png')">
              <Icon type="ios-cloud-download-outline" />下载图片
            </span>
          </div>
        </div>

        <div>
          <div class="upload_img_title">身份证国徽面</div>
          <Upload :on-progress="img_progress" :on-success="img_b_success"
            :action="img_b_url + '&resume_id=' + resume_id" :show-upload-list="false">
            <img v-if="idcard_img_b_url == ''" class="idcard_img" src="@/assets/image/idcard/idcard_b.png" alt="" />
            <img v-else class="idcard_img" :src="idcard_img_b_url" alt="" />
          </Upload>
          <div class="view_idcard_big_img_main">
            <span class="view_idcard_big_img" @click="click_view_img(idcard_img_b_url)">
              <Icon type="ios-eye-outline" />查看大图
            </span>
            <span class="view_idcard_big_img" @click="download_img(idcard_img_b_url, '身份证国徽面.png')">
              <Icon type="ios-cloud-download-outline" />下载图片
            </span>
          </div>
        </div>
      </div>

      <div class="upload_span_txt" style="margin-top: 10px">
        <div class="upload_icon"></div>
        身份证信息<span class="upload_span_txt2">（姓名跟身份证需实名认证，不匹配将无法更新）</span>
      </div>

      <div class="update_idcard_box">
        <div class="idcard_top">
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian">*</span>姓名：</div>
            <Input size="small" v-model="name" placeholder="请输入姓名" clearable maxlength="10" style="width: 120px" />
          </div>
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian">*</span>性别</div>
            <Input maxlength="1" size="small" v-model="gender" placeholder="请输入男或女" clearable style="width: 200px" />
          </div>
        </div>

        <div class="idcard_top">
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian2">*</span>民族：</div>
            <Input size="small" v-model="nation" placeholder="请输入民族，如xx族" clearable maxlength="10"
              style="width: 120px" />
          </div>
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian2">*</span>出生年月：</div>
            <DatePicker v-model="birth_date" type="date" placeholder="请选择出生年月" style="width: 200px" />
          </div>
        </div>
        <div class="idcard_top">
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian2">*</span>住址：</div>
            <Input size="small" v-model="address" placeholder="请输入身份证住址" clearable maxlength="50"
              style="width: 430px" />
          </div>
        </div>
        <div class="idcard_top">
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian">*</span>身份证号：</div>
            <Input maxlength="18" size="small" v-model="idcard" placeholder="请输入身份证号" clearable style="width: 430px" />
          </div>
        </div>
        <div class="idcard_top">
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian2">*</span>发证机关：</div>
            <Input size="small" v-model="idcard_psb" placeholder="请输入发证机关" clearable maxlength="50"
              style="width: 430px" />
          </div>
        </div>
        <div class="idcard_top">
          <div class="idcard_update_field">
            <div class="idcard_field"><span class="bitian2">*</span>有效期：</div>
            <DatePicker type="date" v-model="exp_start" placeholder="有效期开始时间" style="width: 150px" />
            <div style="padding: 0 5px">-</div>
            <DatePicker v-model="exp_end" type="date" placeholder="有效期结束时间" style="width: 150px" />
          </div>
        </div>

        <div class="button_div">
          <span class="button_hint">身份证需实名认证，请输入真实信息</span>
          <Button type="primary" @click="update_idcard_num">确认更新</Button>
        </div>
      </div>
    </Modal>

    <Modal width="550" v-model="nfc_replace_show" title="NFC快捷更新证件信息" :footer-hide="true">
      <div class="nfc_replace_show_div">
        使用提示：请仔细核对身份证号是否一致(防止同名同姓人员)，如果一致点击更新即可，不一致请不要更新，避免数据出错！
        <br />
        规则说明：覆盖时身份证照片实拍的优先，如没有证件照片，会替换为系统合成的照片，有证件照片则不更新照片，身份证文字信息每次更新数据会覆盖更新。
      </div>
      <div>
        <div v-for="(item, i) in swiper_replace_data_list" :key="i" class="swiper_table">
          <div>
            <div>{{ item.name }} - {{ item.id_card_no }}</div>
            <div>
              <span class="look_idcard_img" @click="click_view_img(item.img_a_url)">
                <Icon type="ios-eye" />查看人像面
              </span>
              <span class="look_idcard_img" @click="click_view_img(item.img_b_url)">
                <Icon type="ios-eye" />查看国徽面
              </span>
              <Checkbox v-model="item.replace_img_status" style="font-size:13px;color:#999">是否覆盖当前照片</Checkbox>
            </div>
            <div class="nfc_read_time">读取时间：{{ item.create_time_fmt }}</div>
          </div>
          <div>
            <Button @click="swiper_replace(item)" :loading="swiper_loading" type="primary" >确认覆盖更新</Button>
            <!-- <div class="swiper_update_btn" @click="swiper_replace(item)">确认覆盖更新</div> -->
          </div>
        </div>

      </div>
    </Modal>

    <Modal width="500" v-model="replace_show" title="替换简历" :footer-hide="true">
      <div class="replace_title">
        <Icon type="md-alert" /> 检测到系统已经存在该员工，请确认身份证号一致后进行替换。
      </div>
      <div class="replace_div">
        <div class="resume_box">
          <div class="replace_name">
            <div class="name_field">姓名：</div>
            <div>
              {{ old_resume_info.name }}
            </div>
          </div>
          <div class="replace_name">
            <div class="name_field">身份证号：</div>
            <div>
              {{ old_resume_info.idcard }}
            </div>
          </div>
          <div class="replace_name">
            <div class="name_field">手机号：</div>
            <div>
              {{ old_resume_info.phone }}
            </div>
          </div>
          <div class="replace_name">
            <div class="name_field">实名状态：</div>
            <div>
              {{ old_resume_info.is_certification == 0 ? "未实名" : "已实名" }}
            </div>
          </div>
        </div>
        <div>
          <Icon size="24" type="ios-arrow-dropright-circle" color="#19be6b" />
        </div>

        <div class="resume_box2">
          <div class="replace_name">
            <div class="name_field">姓名：</div>
            <div>
              {{ new_resume_info.name }}
            </div>
          </div>
          <div class="replace_name">
            <div class="name_field">身份证号：</div>
            <div>
              {{ new_resume_info.idcard }}
            </div>
          </div>
          <div class="replace_name">
            <div class="name_field">手机号：</div>
            <div>
              {{ new_resume_info.phone }}
            </div>
          </div>
          <div class="replace_name">
            <div class="name_field">实名状态：</div>
            <div>
              {{ new_resume_info.is_certification == 0 ? "未实名" : "已实名" }}
            </div>
          </div>
        </div>
      </div>
      <div class="button_replace_box">
        <Button type="primary" @click="click_replace_resume" long>确认替换</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { http, download_file } from "@/utils/http.js";

export default {
  name: "update_idcard2",
  components: {},
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      img_a_url:
        process.env.VUE_APP_HOST +
        "/roster_manage/detail/upload_idcard_img_v2?img_type=a&token=" +
        this.$cookies.get("dx_token"),
      img_b_url:
        process.env.VUE_APP_HOST +
        "/roster_manage/detail/upload_idcard_img_v2?img_type=b&token=" +
        this.$cookies.get("dx_token"),

      resume_id: "",
      project_id: "",
      interview_id: "",
      update_idcard_show: false,
      update_idcard_index: "0",

      name: "",
      gender: "男",
      idcard: "",
      nation: "汉族",
      idcard_img_a_url: "",
      idcard_img_b_url: "",
      birth_date: "",
      address: "",
      idcard_psb: "",
      exp_start: "",
      exp_end: "",

      replace_show: false,
      old_resume_info: {},
      new_resume_info: {},

      swiper_replace_data_list: [],
      nfc_replace_show: false,
      swiper_loading: false,
    };
  },

  mounted() {
    this.window_change();
  },

  methods: {
    click_swiper_replace() {
      this.nfc_replace_show = true;
    },

    initialize_params() {
      this.name = "";
      this.gender = "男";
      this.idcard = "";
      this.nation = "汉族";
      this.idcard_img_a_url = "";
      this.idcard_img_b_url = "";
      this.birth_date = "";
      this.address = "";
      this.idcard_psb = "";
      this.exp_start = "";
      this.exp_end = "";
    },

    img_progress() {
      this.$Message.info("正在玩命上传中");
    },

    click_replace_resume() {
      var that = this;
      var obj = {
        old_resume_id: this.resume_id,
        new_resume_id: this.new_resume_info.resume_id,
        interview_id: this.interview_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/update_interview_resume_id",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.replace_show = false;
            that.update_idcard_show = false;
            that.nfc_replace_show = false;

            that.get_resume_idcard_detail();
            that.$emit("change", true);
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    //正面上传成功
    img_a_success(e) {
      console.log(e);
      if (e.code == 0) {
        var url = e.data.url;
        var content = e.data.content;
        this.idcard_img_a_url = url;
        this.$Message.success({
          content: e.msg,
          duration: 4,
          closable: true,
        });

        this.name = content.name;
        if (content.gender == 1) {
          this.gender = "男";
        } else {
          this.gender = "女";
        }
        this.nation = content.race;
        if (content.birth_year > 0) {
          this.birth_date = new Date(
            content.birth_year,
            content.birth_month - 1,
            content.birth_day
          );
        }
        this.address = content.location;
        this.idcard = content.id_card_num;
      } else {
        this.$Message.error({
          content: e.msg,
          duration: 10,
          closable: true,
        });
      }
    },
    //反面上传成功
    img_b_success(e) {
      if (e.code == 0) {
        var url = e.data.url;
        var content = e.data.content;
        this.idcard_img_b_url = url;
        console.log(e);
        this.$Message.success({
          content: e.msg,
          duration: 4,
          closable: true,
        });
        this.idcard_psb = content.id_card_psb;

        if (content.id_card_start_year != "0000") {
          let start_month = parseInt(content.id_card_start_month, 10) - 1;

          this.exp_start = new Date(
            content.id_card_start_year,
            start_month,
            content.id_card_start_day
          );
        }
        if (content.id_card_end_year != "0000") {
          let end_month = parseInt(content.id_card_end_month, 10) - 1;

          this.exp_end = new Date(
            content.id_card_end_year,
            end_month,
            content.id_card_end_day
          );
        }
      } else {
        this.$Message.error({
          content: e.msg,
          duration: 10,
          closable: true,
        });
      }
    },

    //更新身份证号
    update_idcard_num() {
      if (this.name == "") {
        this.$Message.error("请输入姓名");
        return;
      }
      if (this.idcard == "") {
        this.$Message.error("请输入身份证号");
        return;
      }
      if (this.gender == "") {
        this.$Message.error("请输入性别");
        return;
      }

      if (this.birth_date != "") {
        var birth = this.birth_date.getTime() / 1000;
      } else {
        var birth = 0;
      }
      if (this.exp_start != "") {
        var exp_start = this.exp_start.getTime() / 1000;
      } else {
        var exp_start = 0;
      }
      if (this.exp_end != "") {
        var exp_end = this.exp_end.getTime() / 1000;
      } else {
        var exp_end = 0;
      }

      var that = this;
      var obj = {
        resume_id: this.resume_id,
        name: this.name,
        idcard: this.idcard,
        gender: this.gender,
        race: this.nation,
        birth: birth,
        address: this.address,
        idcard_psb: this.idcard_psb,
        exp_start: exp_start,
        exp_end: exp_end,
      };

      console.log(obj);
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/update_idcard_num_v2",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.$emit('change','1')
            that.get_resume_idcard_detail();
          } else {
            if (res.code == 411) {
              console.log("更新简历", res);
              that.replace_show = true;
              that.old_resume_info = res.data.old_resume_info;
              that.new_resume_info = res.data.new_resume_info;
            } else {
              that.$Message.error({
                content: res.msg,
                duration: 3,
              });
            }
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    search_swiper_name() {
      var that = this;
      var obj = {
        name: this.name,
        idcard: this.idcard,
        project_id: this.project_id,
      };

      console.log(obj);
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/swiper_name_search",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.swiper_replace_data_list = res.data.swiper_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    swiper_replace(swiper_item) {
      var that = this;
      var obj = {
        resume_id: this.resume_id,
        swiper_item: swiper_item,
        img_a_url: that.idcard_img_a_url,
        img_b_url: that.idcard_img_b_url,
      };

      this.swiper_loading = true;
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/swiper_replace",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.get_resume_idcard_detail();
            that.nfc_replace_show = false;
          } else {
            if (res.code == 411) {
              that.replace_show = true;
              that.old_resume_info = res.data.old_resume_info;
              that.new_resume_info = res.data.new_resume_info;
            } else {
              that.$Message.error({
                content: res.msg,
                duration: 3,
              });
            }
          }
          that.swiper_loading = false;
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    open(item) {
      this.initialize_params();
      this.resume_id = item.resume_id;
      this.project_id = item.project_id;
      this.interview_id = item.interview_id;
      this.update_idcard_show = true;
      this.get_resume_idcard_detail();
    },

    //获取简历详情
    get_resume_idcard_detail() {
      var that = this;
      var obj = {
        resume_id: this.resume_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/roster_manage/detail/idcard_info",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            console.log(res);
            that.name = res.data.resume_detail.name;
            that.idcard = res.data.resume_detail.idcard;
            that.gender = res.data.resume_detail.gender;
            that.nation = res.data.resume_detail.nation;

            that.address = res.data.resume_detail.address;
            that.idcard_psb = res.data.resume_detail.idcard_psb;
            if (res.data.resume_detail.born > 0) {
              that.birth_date = new Date(res.data.resume_detail.born * 1000);
            }

            if (res.data.resume_detail.exp_start > 0) {
              that.exp_start = new Date(res.data.resume_detail.exp_start * 1000);
            }
            if (res.data.resume_detail.exp_end > 0) {
              that.exp_end = new Date(res.data.resume_detail.exp_end * 1000);
            }

            that.idcard_img_a_url = res.data.resume_detail.idcard_img_a_url;
            that.idcard_img_b_url = res.data.resume_detail.idcard_img_b_url;

            that.search_swiper_name();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },

    click_view_img(url) {
      this.$ImagePreview.show({
        previewList: [url],
      });
    },

    download_img(url, name) {
      download_file(url, name);
      this.$Message.info("下载图片完成");
    },
  },
};
</script>

<style scoped>
.look_idcard_img {
  font-size: 13px;
  margin-right: 10px;
  cursor: pointer;
  color: #0466dd
}

.nfc_read_time {
  color: #ccc;
  font-size: 13px;
}

.nfc_replace_show_div {
  padding: 5px;
  background: rgb(246, 144, 144);
  color: #fff;
  font-size: 13px;
}

.swiper_update_btn {
  background: #0466dd;
  color: #fff;
  cursor: pointer;
  width: 120px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  border-radius: 5px;
}

.swiper_update_btn:hover {
  opacity: 0.9;
}

.swiper_table {
  background: #fff;
  color: #333;
  border: 1px solid #ebebeb;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 5px 0;
}

.swiper_table:hover {
  border: 1px solid #0466dd;
}

.nfc_tishi {
  padding: 5px;
  background: rgb(82, 195, 82);
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  border-radius: 3px;
  margin-bottom: 5px;
}

.nfc_tishi:hover {
  cursor: pointer;
  background-color: #0be076;
}

.upload_span_txt2 {
  font-size: 13px;
  font-weight: 400;
  margin-left: 10px;
  color: #ccc;
}

.upload_icon {
  height: 15px;
  width: 8px;
  border-radius: 3px;
  background: #0466dd;
  margin-right: 5px;
}

.upload_span_txt {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  font-weight: 600;
}

.upload_img_title {
  font-weight: 300;
  color: #ccc;
  width: 200px;
  text-align: center;
}

.upload_img_div {
  padding: 0 20px;
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
}

.button_replace {
  width: 200px;
  height: 40px;
  background: #0466dd;
  color: #fff;
  border-radius: 5px;
}

.button_replace_box {
  display: flex;
  padding: 40px 20px 20px 20px;
  justify-content: center;
}

.replace_title {
  font-size: 13px;
  color: #f42100;
  text-align: center;
  margin-bottom: 20px;
}

.name_field {
  flex-shrink: 0;
  width: 70px;
}

.resume_box2 {
  border: 1px solid rgb(229, 229, 229);
  padding: 10px;
  border-radius: 5px;
  background-color: #19be6b;
  color: #fff;
}

.resume_box {
  border: 1px solid rgb(229, 229, 229);
  padding: 10px;
  background-color: #e7e7e7;

  border-radius: 5px;
}

.replace_name {
  font-size: 13px;
  display: flex;
  align-items: center;
}

.replace_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.view_idcard_big_img_main {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
}

.view_idcard_big_img {
  font-size: 13px;
  color: #ccc;
  cursor: pointer;
  text-align: center;
}

.view_idcard_big_img:hover {
  color: #0466dd;
}

.idcard_img_div {
  padding: 20px;

  display: flex;
  justify-content: space-between;
}

.idcard_img {
  cursor: pointer;
  width: 200px;
  height: 120px;

  border-radius: 10px;
}

.idcard_img:hover {
  border: 1px solid rgb(81, 185, 230);
}

.button_hint {
  font-size: 12px;
  color: #ccc;
}

.bitian {
  color: red;
}

.bitian2 {
  color: #fff;
}

.idcard_top {
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
}

.update_idcard_box {}

.button_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.idcard_field {
  width: 80px;
  flex-shrink: 0;
}

.idcard_update_field {
  display: flex;
  align-items: center;
  margin: 3px 0;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}
</style>
